import { render, staticRenderFns } from "./Azioni.vue?vue&type=template&id=4098dbe1&scoped=true&lang=pug&"
import script from "./Azioni.vue?vue&type=script&lang=ts&"
export * from "./Azioni.vue?vue&type=script&lang=ts&"
import style0 from "./Azioni.vue?vue&type=style&index=0&id=4098dbe1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4098dbe1",
  null
  
)

export default component.exports